import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-controles-bt',
    templateUrl: './controles-bt.component.html',
    styleUrls: ['./controles-bt.component.scss'],
    standalone: false
})
export class ControlesBTComponent implements OnInit {
  public loading = true;

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
